export enum ChatType {
  FARM = 'FARM',
  SUPPLIER = 'SUPPLIER',
}
